import { observer } from 'mobx-react-lite'
import { EmptyState, Typography } from 'shared/ui'
import { LINK_RCS_GUIDE } from 'shared/constants/links'
import rcsPreviewImg from 'shared/assets/images/rcs/rcs_preview.png'
import { getCDNAssetURL } from 'shared/lib'

import styles from './styles.module.scss'
import { CreateRcsButton, GuideRcsButton } from '../RcsAction'

export const RcsEmpty = observer(() => {
  return (
    <section className={styles.empty}>
      <EmptyState
        title={
          <span className={styles.title}>
            <a
              href={LINK_RCS_GUIDE}
              rel='noreferrer'
              target='_blank'
              className={styles.titlePreview}
            >
              <img alt='RCS preview' src={getCDNAssetURL(rcsPreviewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel='RCS'>
              RCS
            </Typography>
          </span>
        }
        actions={
          <div className={styles.actions}>
            <CreateRcsButton />
            <GuideRcsButton className={styles.guideButton} />
          </div>
        }
        text={
          <>
            Next-gen messaging with rich media, branded sender ID, and interactive
            <br />
            features
          </>
        }
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'KnowledgeBaseText',
          marginTop: '4px',
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: 'unset',
          textAlign: 'center',
        }}
        noIcon
      />
    </section>
  )
})
